import Highcharts from 'highcharts/highstock'
import HighchartsTheme from 'components/HighChart/Theme'

// Configure custom theme
Highcharts.theme = HighchartsTheme
Highcharts.setOptions(Highcharts.theme)

export default Highcharts
